/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useMemo} from 'react';
import * as S from '../LoginForm.styles';

import Input from 'components/core/form/Input';
import Button from 'components/core/Button';
import Link from 'components/core/Link';

import {useForm} from 'react-hook-form';
import * as yup from 'yup';
import useYupValidationResolver from 'hooks/useYupValidationResolver';
import {useDispatch, useSelector} from 'react-redux';
import HandleMessage from 'components/core/HandleMessage';
import {isPending, isReject} from 'lib/core/request';

import {AuthActions} from 'store/auth/auth.ducks';
import Loading from 'components/core/Loading';

const Forgot = ({setForm}) => {
  const dispatch = useDispatch();
  const {authRequests, error} = useSelector(({auth}) => auth);

  const validationSchema = useMemo(
    () =>
      yup.object({
        email: yup
          .string()
          .required('Campo de e-mail obrigatório')
          .email('Digite um e-mail válido'),
      }),
    [],
  );
  const resolver = useYupValidationResolver(validationSchema);

  const {register, handleSubmit, errors, clearErrors} = useForm({resolver});

  const forgotPassword = (data) => {
    dispatch(AuthActions.forgotPassword(data));
  };

  return (
    <S.FormLogin onSubmit={handleSubmit(forgotPassword)}>
      <S.Title>
        Informe o seu <b>email cadastrado </b>para enviarmos sua nova senha
      </S.Title>
      <Input
        label="Seu e-mail"
        placeholder="Informe seu email"
        defaultValue=""
        name="email"
        inputRef={register}
        errors={errors.email && errors.email.message}
      />

      <S.FormGroup>
        <Link
          onClick={() => {
            setForm('login');
            clearErrors();
          }}>
          Voltar
        </Link>
      </S.FormGroup>

      <Button
        type="submit"
        color="primary"
        disabled={isPending(authRequests.FORGOT_PASSWORD)}>
        {isPending(authRequests.FORGOT_PASSWORD) ? <Loading /> : 'Continuar'}
      </Button>
      {isReject(authRequests.FORGOT_PASSWORD) ? (
        <S.FormGroup>
          <HandleMessage type="error">{error.data.errors[0]}</HandleMessage>
        </S.FormGroup>
      ) : null}
    </S.FormLogin>
  );
};

export default Forgot;
